import {
  Article as ArticleIcon,
  Checklist as ChecklistIcon,
  CorporateFare as CorporateFareIcon,
  Description as DescriptionIcon,
  Difference as DifferenceIcon,
  FactCheck as FactCheckIcon,
  Folder as FolderIcon,
  Handshake as HandshakeIcon,
  LocalHospital as LocalHospitalIcon,
  Lock as LockIcon,
  LockPerson as LockPersonIcon,
  People as PeopleIcon,
  PeopleOutline as PeopleOutlineIcon,
  Policy as PolicyIcon,
  Redeem as RedeemIcon,
  RequestQuote as RequestQuoteIcon,
  DriveFolderUpload as DriveFolderUploadIcon,
  SvgIconComponent,
} from "@mui/icons-material";
import { ResourceName } from "@/types";

export const resourceIcons: Record<ResourceName, SvgIconComponent> = {
  [ResourceName.CLIENTS]: CorporateFareIcon,
  [ResourceName.STOPLOSS_CLAIMS]: RedeemIcon,
  [ResourceName.CLAIM_ITEMS]: ArticleIcon,
  [ResourceName.CLAIMANTS]: PeopleIcon,
  // Two overlapping records being compared — the duplicate review queue (#6717).
  [ResourceName.DUPLICATE_CLAIMANT_PAIRS]: DifferenceIcon,
  [ResourceName.POLICIES]: PolicyIcon,
  [ResourceName.USERS]: PeopleOutlineIcon,
  [ResourceName.REIMBURSEMENTS]: RequestQuoteIcon,
  [ResourceName.VENDORS]: LocalHospitalIcon,
  [ResourceName.DOCUMENTS]: DescriptionIcon,
  [ResourceName.TASKS]: ChecklistIcon,
  [ResourceName.ROLES]: LockPersonIcon,
  [ResourceName.PERMISSIONS]: LockIcon,
  [ResourceName.PARTNERS]: HandshakeIcon,
  [ResourceName.DOCUMENT_TRANSFORMATIONS]: DescriptionIcon,
  [ResourceName.AUDIT]: FactCheckIcon,
  [ResourceName.DOCUMENT_LOADS]: DriveFolderUploadIcon,
};

export const getResourceIcon = (resourceName: ResourceName): SvgIconComponent => {
  return resourceIcons[resourceName] || FolderIcon;
};
